import React from "react";
import { Avatar, Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";
import { LEVELS_BACKEND } from "../../components/Badges/Status";
import { I18N_NS_EXPENSE } from "../../constants";
import { Trans, useTranslation } from "react-i18next";
import EvolutionComment from "./EvolutionComment";
import moment from "moment";

// "created",
// LEVELS.approuve,
// LEVELS.pending,
// LEVELS.recognised,
// LEVELS.refuse,

const ChatMessage = ({
    avatar,
    full_name,
    date,
    status,
    comment,
    amount_approved,
    currency,
}) => {
    const { t } = useTranslation(I18N_NS_EXPENSE);

    const FIXED_SENTENCES = [
        "/",
        <Text key="1">
            <Trans t={t} i18nKey={"report_detail.messages.approbation"}>
                <strong>Approbation</strong> de la note pour un montant de
            </Trans>
        </Text>,
        <Text key="2">
            <Trans t={t} i18nKey={"report_detail.messages.sent"}>
                <strong>Envoi</strong> de la note pour approbation
            </Trans>
        </Text>,
        <Text key="3">
            <Trans t={t} i18nKey={"report_detail.messages.validation"}>
                <strong>Validation</strong> de la note
            </Trans>
        </Text>,
        <Text key="4">
            <Trans t={t} i18nKey={"report_detail.messages.refused"}>
                <strong>Refus</strong> de la note
            </Trans>
        </Text>,
    ];

    const _get_sentence_depending_status = ({ status }) => {
        return FIXED_SENTENCES[status];
    };

    const sentence = _get_sentence_depending_status({
        status,
    });

    const format_date = moment(date, "YYYY-MM-DD HH:mm").format(
        "HH:mm - DD/MM/YYYY"
    ); // format to "15:38 - 25/10/2022"

    return (
        <EvolutionComment
            comments={[
                {
                    user_fullname: full_name,
                    user_avatar: avatar,
                    date: format_date,
                    type: status,
                    description: (
                        <Flex column>
                            <Flex>
                                <Trans t={t} i18nKey={sentence}>
                                    {sentence}{" "}
                                </Trans>
                                {amount_approved && (
                                    <i>
                                        &nbsp;{amount_approved + " " + currency}
                                    </i>
                                )}
                            </Flex>
                            {comment && (
                                <Flex styles={{ marginTop: "15px" }}>
                                    <Text>
                                        <u>
                                            {t(
                                                "forms.classic.fields.comment.label"
                                            )}
                                        </u>{" "}
                                        : {comment}
                                    </Text>
                                </Flex>
                            )}
                        </Flex>
                    ),
                },
            ]}
        />
    );
};

export default ChatMessage;

export const MessageText = styled(Text)`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #242424;
`;

export const Message = styled(Flex)`
    background: #f0f0f0;
    padding: 6px 12px;
    border-radius: 2px;
`;
